import { useIdioma, type Traducir } from '../../i18n/idioma';
import React from 'react';
import { CAPTURA_ANCHO, CAPTURA_ALTO, type Captura } from './capturas';

interface Props {
    captura: Captura;
}

/**
 * Una pantalla real de la app, enmarcada.
 *
 * El marco es deliberadamente flojo: esquinas redondeadas, un filete de
 * hairline y una sombra larga. Nada de cromo de navegador con el semáforo
 * rojo/amarillo/verde — eso no existe en la aplicación, le pone fecha de
 * caducidad a la página y es de los gestos que el equipo señaló como «de IA».
 *
 * `sizes` declara los dos anchos que puede ocupar de verdad: 600 px en la
 * columna pegada de escritorio, y el ancho completo del teléfono. Sin esto el
 * navegador supone 100vw siempre y en un portátil se baja la de 1200 para
 * pintarla a 600.
 */
const CapturaApp: React.FC<Props> = ({ captura }) => {
    const { t } = useIdioma();
    return (
    <img
        src={captura.src}
        srcSet={captura.srcSet}
        sizes="(min-width: 1024px) 600px, 100vw"
        alt={t((captura.alt) as Parameters<Traducir>[0])}
        /* Medidas reales del archivo: el navegador reserva el hueco antes de
           que llegue el primer byte y la página no da el salto. */
        width={CAPTURA_ANCHO}
        height={CAPTURA_ALTO}
        /* Todas en diferido: este fold es el tercero de la página, ninguna
           captura está nunca en el primer pliegue. Además cada una se pinta
           dos veces en el árbol (la versión de móvil y la de escritorio), y
           marcar una como `eager` hacía que el navegador también bajase la
           copia oculta por `display:none`. */
        loading="lazy"
        decoding="async"
        className="rp-captura w-full"
    />
    );
};

export default CapturaApp;
